export default {
    "Add language": "Ajouter une langue",
    "Add": "Ajouter",
    "Edit language": "Modifier la langue",
    "Edit": "Modifier",
    "Delete field": "Supprimer le champ",
    "Are you sure you want to delete": "Êtes-vous sûr de vouloir supprimer",
    "Delete": "Supprimer",
    "Delete language": "Supprimer la langue",
    "Settings": "Paramètres",
    "Fields": "Champs",
    "Add field": "Ajouter un champ",
    "Back": "Retour",
    "Empty": "Vide",
    "Remove all?": "Supprimer tout ?",
    "Are you sure you want to remove all items? This action cannot be undone.": "Êtes-vous sûr de vouloir supprimer tous les éléments ? Cette action ne peut pas être annulée.",
    "Remove all": "Supprimer tout",
    "Cancel": "Annuler",
    "Reload": "Recharger",
    "Export": "Exporter",
    "No result yet": "Aucun résultat pour le moment",
    "Load more": "Charger plus",
    "Yes": "Oui",
    "No": "Non",
    "Break lines to enter multiple values": "Sauter des lignes pour entrer plusieurs valeurs",
    "Optional": "Optionnel",
    "This field is mandatory": "Ce champ est obligatoire"
}